import { gql } from "apollo-boost";

export const MY_OPEN_HOUSES = gql`
  query MyOpenHouses($listing_type: PropertyType!) {
    my_open_houses(listing_type: $listing_type) {
      recent {
        date
        my_open_house_items {
          open_house {
            id
            starts_at
            ends_at
          }
          oh_starts_on
          oh_ends_at
          oh_cancelled
          oh_time_changed
          saved_open_house_id
          listing_title_with_unit
          listing_url
          listing_medium_image_uri
          saved_open_house_id
          attended
          oh_confirmed_with_agent
        }
      }
      upcoming {
        date
        my_open_house_items {
          open_house {
            id
            starts_at
            ends_at
          }
          oh_starts_on
          oh_ends_at
          oh_cancelled
          oh_time_changed
          saved_open_house_id
          listing_id
          listing_title_with_unit
          listing_url
          listing_medium_image_uri
          saved_open_house_id
          attended
          oh_confirmed_with_agent
        }
      }
    }
  }
`;
